import script from "./LayerPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./LayerPanel.vue?vue&type=script&setup=true&lang=ts"

import "./LayerPanel.vue?vue&type=style&index=0&id=08b4da32&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08b4da32"]])

export default __exports__